import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { isWalletDesignPreviewRequest, isWalletPassServiceRequest } from "../wallet-request.util";
import { buildWalletDesignPreviewMock } from "./wallet-pass-preview-mock";

function extractProgramId(url: string): string | null {
  const match = /\/programs\/([^/]+)\/design-config\/preview/.exec(url);
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

/**
 * Dev-only optional bypass: when `environment.walletDesignPreviewMock` is true,
 * serve Design preview from local fixtures. Default is false (real wallet-pass API).
 */
@Injectable({ providedIn: "root" })
export class WalletPassPreviewMockInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!environment.walletDesignPreviewMock) {
      return next.handle(req);
    }
    if (req.method !== "GET" || !isWalletPassServiceRequest(req.url) || !isWalletDesignPreviewRequest(req.url)) {
      return next.handle(req);
    }

    const programId = extractProgramId(req.url) ?? "demo";
    const platformParam = req.params.get("platform") ?? new URL(req.url, "http://local").searchParams.get("platform");
    const platform = platformParam === "android" ? "android" : "ios";
    const acceptLanguage = req.headers.get("Accept-Language") ?? "en";

    return of(
      new HttpResponse({
        status: 200,
        body: buildWalletDesignPreviewMock({ programId, platform, acceptLanguage }),
      }),
    );
  }
}
